import React from 'react'
import styled from 'styled-components'

const MonoFooterSvg = styled.div`
    display: ${props => (props.theme.is_footer_visible ? 'block' : 'none')};
    position: fixed;
    bottom: -5px;
    width: 50%;

    .prefix__main {
        fill: ${_ => _.theme.kiosks_background[_.kiosk]};
    }
    .prefix__st0 {
        fill: none;
        stroke: #fff;
        stroke-width: 0.8;
        stroke-miterlimit: 10;
    }
`

function Footer(props) {
    return (
        <svg
            id="prefix__Calque_1"
            x={0}
            y={0}
            viewBox="0 0 181 16.9"
            xmlSpace="preserve"
            {...props}
        >
            <style>
                {
                    '.prefix__st0{fill:none;stroke:#fff;stroke-width:.8;stroke-miterlimit:10}'
                }
            </style>
            <path
                className="prefix__main"
                d="M0 9.2V1.7l1.6.1c.9.1 5.7.5 10.7.9 35.6 2.7 59.9 2.6 81-.1 6.2-.8 15.3-1.5 25.1-2 13.9-.6 45.2-.1 59.6.9l3 .2v15.2H0V9.2z"
            />
            <path
                className="prefix__st0"
                d="M181 9.3c-11.3 0-29.4-5.1-42.1-5.3-38.1-.7-43.6 3.3-55.8 4.2-32.5 2.3-44.8 1.7-54.2.9-1.4-.1-9.6-.9-11-1.1C16.7 7.8 3.8 6.4 0 6.4"
            />
            <path
                className="prefix__st0"
                d="M181 6.4c-37.3 0-63 2.2-73.2 2.9S73.3 7.2 58.4 6.4c-12.7-.7-40.1 3.8-48.1 5.2-1.8.3-3.5.5-5.3.6-1.6.1-3.5.2-4.9.2"
            />
            <path
                className="prefix__st0"
                d="M181 12.4c-11.6.1-58-6-72.3-6s-40.5 4.1-52.9 4.8S4.1 9.5 4.1 9.5 1.6 9.3 0 9.3"
            />
        </svg>
    )
}

const MonoFooter = ({ kiosk, fullWidth }) => (
    <>
        <MonoFooterSvg
            kiosk={kiosk}
            fullWidth={fullWidth}
            style={{ left: fullWidth ? '0' : 'inherit' }}
        >
            <Footer />
        </MonoFooterSvg>
        {fullWidth && (
            <MonoFooterSvg
                kiosk={kiosk}
                fullWidth={fullWidth}
                style={{ left: fullWidth ? '50%' : 'inherit' }}
            >
                <Footer />
            </MonoFooterSvg>
        )}
    </>
)

export default MonoFooter
